/**
 * The admin's own user id, stored when an impersonation begins so the impersonation check has a
 * durable datum to compare the live session against.
 *
 * It replaces decoding the parked ACCESS token, which is undecidable across a browser restart: the
 * parked access lives in a 14-minute cookie and sessionStorage (wiped on close), while the parked
 * refresh lingers for 90 days in localStorage. An id in localStorage does not inherit that expiry
 * asymmetry, so the comparison holds after a restart.
 *
 * localStorage, not a cookie: this is read client-side only, and localStorage is the store the token
 * fallback already trusts inside the Android WebView. Every access is guarded — storage can throw in
 * a private context — and a failure leaves the check on its parked-token fallback, i.e. today's
 * behaviour.
 */
export const IMPERSONATOR_USER_ID_STORAGE_KEY = 'xceed-impersonator-user-id';
